import { render, staticRenderFns } from "./MyPageSave.vue?vue&type=template&id=f1cbc7d8&scoped=true"
import script from "./MyPageSave.vue?vue&type=script&lang=js"
export * from "./MyPageSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cbc7d8",
  null
  
)

export default component.exports